import { auth, firestore } from "../firebase";

export function authUser(userName, password) {
  return auth
    .signInWithEmailAndPassword(userName, password)
    .then((resp) => {
      return {success: true, email: userName}
    })
    .catch((err) => ({success: false, message: err.message}));
}

export async function getCurrentUser(uid) {
  const doc = await firestore.collection('users').doc(uid).get();
  if (!doc.exists) {
    return {exists: false}
  } else {
    const data = doc.data()
    return {exists: true, uid: doc.id, ...data}
  }
}

export async function resetPassword(email) {

  return auth.sendPasswordResetEmail(email)
		.then(() => {
			return true;
		})
		.catch(error => {
			return error.message
		});
}

export async function getPlans(){
  const p = [];
  const snapshot = await firestore.collection("plans").orderBy("productName", "asc").get()
  if(snapshot.empty){
    console.log("no plans");
  }else{
    snapshot.forEach((doc) => {
      p.push({id:doc.id, ...doc.data()})
    });
  }
  return p
}

export async function disableUser(email){
  await firestore.collection("users").doc(email).update({disabled: true});
  return true
}

export const logout = async () => {
  await auth.signOut()
}